let key = {};
// if (process.env.NODE_ENV === "production") {
if (process.env.REACT_APP_MODE === "production") {
    const API_URL = 'https://deepliquidity.exchange';

    key = {
        secretOrKey: "FxUum76z",
        Recaptchakey: "6Lf-oQAaAAAAAHsxE5WyOHwmKav2lOfeL5KeA7AV", //local
        API_URL: `${API_URL}/deepliquidityapi`,
        FRONT_URL: 'https://deepliquidity.exchange/Deepliquidity',
        ADMIN_URL: 'https://deepliquidity.exchange/Deepliquidity/admin',
        TRADE_URL: 'https://java.deepliquidity.exchange/api/trade',
        getGeoInfo: "https://ipapi.co/json/",
        CRYPTO_SECRET_KEY: "1234567812345678",
        socialMedia: {
            facebook: {
                appId: "1034988646970193"
            },
            linkedIn: {
                clientId: '78szlpfkw7ee7s',
                redirectUrl: 'https://99893158a13c.ngrok.io/signup',
                oauthUrl: 'https://www.linkedin.com/oauth/v2/authorization?response_type=code',
                scope: 'r_liteprofile%20r_emailaddress',
                state: '123456'
            }
        },
        ADMIN_WALLET_ADDRESS: '0xC5c2F21e0CDaC11fb707753ED348100Fe68CB4D3'.toLowerCase()

    };

} else {
    const API_URL = 'http://localhost';
    key = {
        secretOrKey: "FxUum76z",
        Recaptchakey: "6LdpeoQUAAAAAHwFEDfpcA-W5-leSH8548lZWWeb", //local
        API_URL: `${API_URL}:3001/deepliquidityapi`,
        TRADE_URL: 'http://54.211.230.83:8081/api/trade',
        CRYPTO_SECRET_KEY: "1234567812345678",
        getGeoInfo: "https://ipapi.co/json/",

        socialMedia: {
            facebook: {
                appId: "1034988646970193"
            },
            linkedIn: {
                clientId: '78szlpfkw7ee7s',
                redirectUrl: 'https://99893158a13c.ngrok.io/signup',
                oauthUrl: 'https://www.linkedin.com/oauth/v2/authorization?response_type=code',
                scope: 'r_liteprofile%20r_emailaddress',
                state: '123456'
            }
        },
        ADMIN_WALLET_ADDRESS: '0xC5c2F21e0CDaC11fb707753ED348100Fe68CB4D3'.toLowerCase()

    };
}



export default key;